export default __webpack_public_path__ + "static/media/mouvment.5c8d6bc2.webm";